<template>
	<div v-if="chartsData" class="finance-tab">
		<div class="body-text-1">{{ subtitle }}</div>
		<ja-pie-chart
			v-for="chart in chartsData"
			:key="chart.title"
			:data="chart"
			legend="column"
			class="chart"
		></ja-pie-chart>
	</div>
</template>
<script>
import PieChart from '../Chart/PieChart';

export default {
	components: {
		jaPieChart: PieChart
	},
	props: {
		subtitle: {
			type: String,
			default: ''
		},
		chartsData: {
			type: Array,
			default: null
		}
	}
};
</script>
<style lang="scss" scoped>
.finance-tab {
	.body-text-1 {
		text-align: left;
		margin-bottom: 32px;
	}
	.chart {
		&:not(:last-child) {
			margin-bottom: 32px;
		}
	}
}
</style>
